import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { EditorEligibilityRuleHasDiscreteUserField } from '../editor-eligibility-rule/editor-eligibility-rule-has-discrete-user-field.model';


@Component({
    selector: 'eas-editor-eligibility-rule-value-is-raw-operator',
    templateUrl: './editor-eligibility-rule-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleValueIsRawOperatorComponent implements OnInit, OnChanges {
  @Input() rule: EditorEligibilityRuleHasDiscreteUserField;
  @Input() affirmative: boolean;

  value: string;

  constructor() {

  }

  ngOnInit() {
    this.value = this.getValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }
  getValue(): string {
    return this.affirmative
      ? $localize `This operator must return TRUE`
      : $localize `This operator must return FALSE`;
  }
}
